import React from "react";
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import PrivateRoute from "./PrivateRoute";
import styled from "styled-components";
import { Box } from "@material-ui/core";

// Components
import LoginPage from "../pages/Login";
import AppointmentsPage from "../pages/Appointments";
import CircularProgress from "@material-ui/core/CircularProgress";
import NewAppointmentPage from "../pages/NewAppointment";
import RescheduleAppointmentPage from "../pages/RescheduleAppointment";
import CancelAppointmentPage from "../pages/CancelAppointment";

import HeaderBar from "../components/HeaderBar";
import FooterBar from "../components/FooterBar";

// Utilities
import * as routes from "../constants/routes";

// styled components
const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

/**
 * Main application router
 *
 * @returns {React.Element} The app router.
 */
const AppRouter = () => {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  return (
    <Router>
      <Switch>
        <Route
          path={routes.login}
          component={() => (
            <>
              <HeaderBar />
              <LoginPage />
              <FooterBar />
            </>
          )}
        />
        <PrivateRoute
          exact
          path={routes.appointments}
          component={AppointmentsPage}
        />
        <PrivateRoute
          path={routes.appointmentNew}
          component={NewAppointmentPage}
        />
        <PrivateRoute
          path={routes.appointmentReschedule}
          component={RescheduleAppointmentPage}
        />
        <PrivateRoute
          path={routes.appointmentCancel}
          component={CancelAppointmentPage}
        />
        <Redirect exact from="/" to={routes.login} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
